import { Injectable, OnInit } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router
} from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { UserConfigService } from '../services/userConfig.service';
import { AppConfigService } from 'src/modules/shared/services/app-config.service';
import { IGetOperationResponse } from '../interfaces/IGetOperationResponse';
import { LoaderService } from '../services/loader.service';

@Injectable({
  providedIn: 'root'
})
export class IsProfileOwnerGuard implements CanActivate {
  
  private baseUrl: string;
  applicant:any;
  constructor(private http: HttpClient, private router: Router, private userConfigService: UserConfigService, private appConfig: AppConfigService) {
    this.baseUrl = this.appConfig.getAppConfig().AppUrl;

  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    LoaderService.showLoader();
    let applicant = history.state.applicant !== null && history.state.applicant !== undefined ? history.state.applicant : null;
    return this.http.get(this.baseUrl + '/api/UserDataManager/CheckIfTheSelectedApplicantIsTheLoggedInUser?cpr='+applicant.CPRNo).pipe(map((response :IGetOperationResponse<boolean> )=> {
      if(response && response.Result){
       // LoaderService.hideLoader();
        return true
      }else{
        LoaderService.hideLoader();
        return false;
      }
    }),catchError(err=>{
      LoaderService.hideLoader()
      return of(false);
    }));
  }
  path: import("@angular/router").ActivatedRouteSnapshot[]; route: import("@angular/router").ActivatedRouteSnapshot;
  
}
